import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/HomeView.vue";
import DistributorMain from "../views/DistributorMgt/DistributorMain.vue";
import RetailMain from "../views/RetailMgt/RetailMain.vue";
import StoreMain from "../views/StoreMgt/StoreMain.vue";
import TargetMain from "../views/TargetMgt/TargetMain.vue";
import Target from "../views/TargetMgt/target.vue";
import TargetAdmin from "../views/TargetMgt/TargetForAdmin.vue";
import UserMain from "../views/UserMgt/UserMain.vue";
import VisitingMain from "../views/VisitingMgt/VisitingMain.vue";
import Store from "../views/StoreMgt/Store.vue";
import StoreDetail from "../views/StoreMgt/StoreDetail.vue";
import StoreList from "../views/StoreMgt/StoreForSales.vue";
import Distributor from "../views/DistributorMgt/Distributor.vue";
import DistributorDetail from "../views/DistributorMgt/DistributorDetail.vue";
import DistributorList from "../views/DistributorMgt/DistributorForSales.vue";
import Visiting from "../views/VisitingMgt/Visiting.vue";
import VisitingDetail from "../views/VisitingMgt/VisitingDetail.vue";
import VisitingList from "../views/VisitingMgt/VisitingAdmin.vue";
import User from "../views/UserMgt/User.vue";
import UserDetail from "../views/UserMgt/UserDetail.vue";
import Cookie from "js-cookie";
//const OAUTH_URL = process.env.VUE_APP_OAUTH_URL;
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/distributor",
    name: "Distributor",
    component: Distributor,
    children: [
      {
        path: "",
        name: "DistributorMgt",
        component: DistributorMain,
      },
      {
        path: "list",
        name: "DistributorList",
        component: DistributorList,
      },
      {
        name: "DistributorDetail",
        path: "detail/:id",
        component: DistributorDetail,
      },
    ],
  },
  {
    path: "/retail",
    name: "RetailMgt",
    component: RetailMain,
  },
  {
    path: "/store",
    name: "Store",

    component: Store,
    children: [
      {
        path: "",
        name: "StoreMgt",
        component: StoreMain,
      },
      {
        path: "list",
        name: "StoreList",
        component: StoreList,
      },
      {
        name: "StoreDetail",
        path: "detail/:id",
        component: StoreDetail,
      },
    ],
  },
  {
    path: "/target",
    name: "Target",
    component: Target,
    children: [
      {
        path: "",
        name: "TargetMgt",
        component: TargetMain,
      },
      {
        path: "admin",
        name: "TargetAdmin",
        component: TargetAdmin,
      },
    ],
  },
  {
    path: "/user",
    name: "User",
    component: User,
    children: [
      {
        path: "",
        name: "UserMgt",
        component: UserMain,
      },
      {
        path: "detail/:id",
        name: "UserDetail",
        component: UserDetail,
      },
    ],
  },
  {
    path: "/visiting",
    name: "Visiting",
    component: Visiting,
    children: [
      {
        path: "",
        name: "VisitingMgt",
        component: VisitingMain,
      },
      {
        path: "list",
        name: "VisitingList",
        component: VisitingList,
      },
      {
        path: "listByDealer",
        name: "VisitingListByDealer",
        component: VisitingList,
      },
      {
        path: "detail/:id",
        name: "VisitingDetail",
        component: VisitingDetail,
      }
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  const token = Cookie.get("adfs-token");
  const error_code = Cookie.get("error_code");
  if (token) {
    console.log(to, from);
    // if (
    //   to.name == "TargetMgt" &&
    //   (from.name == "DistributorList" || from.name == "StoreList") &&
    //   !to.query.region &&
    //   !to.query.city &&
    //   !to.query.salesId &&
    //   !to.query.province
    // ) {
    //   next({
    //     name: "TargetMgt",
    //     query: from.query,
    //   });
    // } else {
    //   next();
    // }

    // var userAgentInfo = navigator.userAgent;
    // var Agents = ["Android", "iPhone",
    // "SymbianOS", "Windows Phone",
    // "iPad", "iPod"];
    // var flagPc = true;
    // for (var v = 0; v < Agents.length; v++) {
    //   if (userAgentInfo.indexOf(Agents[v]) > 0) {
    //     flagPc = false;
    //     break;
    //   }
    // }
    
    var flagPc = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );

    if(to.path == "/store"&&!flagPc){
      // window.location.href = "https://dev.salesclub.bosch-homecomfort.cn/rec/index.html#/";
        window.location.href = process.env.VUE_APP_HOME_REC;
      return false;
    }else{
      if (to.path == "/") {
        store.state.back = [];
        Cookie.set("back", JSON.stringify([]));
      } else if (store.state.back.filter((i) => i.name === from.name)) {
        store.state.back.push({
          name: from.name,
          path: from.path,
          query: from.query,
          params: from.params,
        });
        Cookie.set("back", JSON.stringify(store.state.back));
      }
      next();
      Cookie.remove("error_code");
    }
    
  } else if (error_code == "9999") {
    alert(Cookie.get("error_msg"));
    Cookie.remove("error_code");
    return false;
  } else if (error_code == "16004") {
    alert("未查询到用户信息");
    Cookie.remove("error_code");
    return false;
  } else if (error_code == "9016") {
    alert("登录请求过期");
    Cookie.remove("error_code");
    return false;
  } else {
    // window.location.href = process.env.VUE_APP_API_BASE_URL + "rec/index.html#/login";
    window.location.href = process.env.VUE_APP_HOME_REC + "login";
    return false;
  }
});

export default router;
